/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SecondFactorStateDto } from './SecondFactorStateDto';
import {
    SecondFactorStateDtoFromJSON,
    SecondFactorStateDtoFromJSONTyped,
    SecondFactorStateDtoToJSON,
    SecondFactorStateDtoToJSONTyped,
} from './SecondFactorStateDto';
import type { PortalAccountStateDto } from './PortalAccountStateDto';
import {
    PortalAccountStateDtoFromJSON,
    PortalAccountStateDtoFromJSONTyped,
    PortalAccountStateDtoToJSON,
    PortalAccountStateDtoToJSONTyped,
} from './PortalAccountStateDto';

/**
 * 
 * @export
 * @interface PortalAccountStatusResponse
 */
export interface PortalAccountStatusResponse {
    /**
     * 
     * @type {PortalAccountStateDto}
     * @memberof PortalAccountStatusResponse
     */
    state: PortalAccountStateDto;
    /**
     * 
     * @type {string}
     * @memberof PortalAccountStatusResponse
     */
    email: string | null;
    /**
     * 
     * @type {Date}
     * @memberof PortalAccountStatusResponse
     */
    invitationSentAtUtc: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof PortalAccountStatusResponse
     */
    resendPossibleAtUtc: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof PortalAccountStatusResponse
     */
    resendAllowed: boolean;
    /**
     * 
     * @type {Date}
     * @memberof PortalAccountStatusResponse
     */
    registeredAtUtc: Date | null;
    /**
     * 
     * @type {SecondFactorStateDto}
     * @memberof PortalAccountStatusResponse
     */
    secondFactor: SecondFactorStateDto;
    /**
     * 
     * @type {string}
     * @memberof PortalAccountStatusResponse
     */
    secondFactorMethod: string | null;
    /**
     * 
     * @type {string}
     * @memberof PortalAccountStatusResponse
     */
    identityDocumentType: string | null;
    /**
     * 
     * @type {string}
     * @memberof PortalAccountStatusResponse
     */
    identityDocumentNumber: string | null;
    /**
     * 
     * @type {string}
     * @memberof PortalAccountStatusResponse
     */
    identityDocumentIssuingAuthority: string | null;
    /**
     * 
     * @type {Date}
     * @memberof PortalAccountStatusResponse
     */
    identityDocumentValidUntil: Date | null;
}



/**
 * Check if a given object implements the PortalAccountStatusResponse interface.
 */
export function instanceOfPortalAccountStatusResponse(value: object): value is PortalAccountStatusResponse {
    if (!('state' in value) || value['state'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('invitationSentAtUtc' in value) || value['invitationSentAtUtc'] === undefined) return false;
    if (!('resendPossibleAtUtc' in value) || value['resendPossibleAtUtc'] === undefined) return false;
    if (!('resendAllowed' in value) || value['resendAllowed'] === undefined) return false;
    if (!('registeredAtUtc' in value) || value['registeredAtUtc'] === undefined) return false;
    if (!('secondFactor' in value) || value['secondFactor'] === undefined) return false;
    if (!('secondFactorMethod' in value) || value['secondFactorMethod'] === undefined) return false;
    if (!('identityDocumentType' in value) || value['identityDocumentType'] === undefined) return false;
    if (!('identityDocumentNumber' in value) || value['identityDocumentNumber'] === undefined) return false;
    if (!('identityDocumentIssuingAuthority' in value) || value['identityDocumentIssuingAuthority'] === undefined) return false;
    if (!('identityDocumentValidUntil' in value) || value['identityDocumentValidUntil'] === undefined) return false;
    return true;
}

export function PortalAccountStatusResponseFromJSON(json: any): PortalAccountStatusResponse {
    return PortalAccountStatusResponseFromJSONTyped(json, false);
}

export function PortalAccountStatusResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortalAccountStatusResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'state': PortalAccountStateDtoFromJSON(json['state']),
        'email': json['email'],
        'invitationSentAtUtc': (json['invitationSentAtUtc'] == null ? null : new Date(json['invitationSentAtUtc'])),
        'resendPossibleAtUtc': (json['resendPossibleAtUtc'] == null ? null : new Date(json['resendPossibleAtUtc'])),
        'resendAllowed': json['resendAllowed'],
        'registeredAtUtc': (json['registeredAtUtc'] == null ? null : new Date(json['registeredAtUtc'])),
        'secondFactor': SecondFactorStateDtoFromJSON(json['secondFactor']),
        'secondFactorMethod': json['secondFactorMethod'],
        'identityDocumentType': json['identityDocumentType'],
        'identityDocumentNumber': json['identityDocumentNumber'],
        'identityDocumentIssuingAuthority': json['identityDocumentIssuingAuthority'],
        'identityDocumentValidUntil': (json['identityDocumentValidUntil'] == null ? null : new Date(json['identityDocumentValidUntil'])),
    };
}

export function PortalAccountStatusResponseToJSON(json: any): PortalAccountStatusResponse {
    return PortalAccountStatusResponseToJSONTyped(json, false);
}

export function PortalAccountStatusResponseToJSONTyped(value?: PortalAccountStatusResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'state': PortalAccountStateDtoToJSON(value['state']),
        'email': value['email'],
        'invitationSentAtUtc': value['invitationSentAtUtc'] == null ? value['invitationSentAtUtc'] : value['invitationSentAtUtc'].toISOString(),
        'resendPossibleAtUtc': value['resendPossibleAtUtc'] == null ? value['resendPossibleAtUtc'] : value['resendPossibleAtUtc'].toISOString(),
        'resendAllowed': value['resendAllowed'],
        'registeredAtUtc': value['registeredAtUtc'] == null ? value['registeredAtUtc'] : value['registeredAtUtc'].toISOString(),
        'secondFactor': SecondFactorStateDtoToJSON(value['secondFactor']),
        'secondFactorMethod': value['secondFactorMethod'],
        'identityDocumentType': value['identityDocumentType'],
        'identityDocumentNumber': value['identityDocumentNumber'],
        'identityDocumentIssuingAuthority': value['identityDocumentIssuingAuthority'],
        'identityDocumentValidUntil': value['identityDocumentValidUntil'] == null ? value['identityDocumentValidUntil'] : `${value['identityDocumentValidUntil'].getFullYear()}-${String(value['identityDocumentValidUntil'].getMonth()+1).padStart(2,'0')}-${String(value['identityDocumentValidUntil'].getDate()).padStart(2,'0')}`,
    };
}

